import React, { useEffect, useState } from "react";
import logo from "../logo.png";
import userIcon from "../user.png";

const Header = () => {
  const [kitchenId, setKitchenId] = useState("");
  const [role_id, setrole_id] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setKitchenId(user);
      setrole_id(user.role);
    }
  }, []);
  return (
    <>
      <header className="App-header navbar-top mb-3 mb-md-0">
        <nav className="navbar navbar-light navbar-glass navbar-top navbar-expand-lg">
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center w-100 p-2">
              {/* Left Side - Logo */}
              <div className="d-flex align-items-center">
                <span className="navbar-brand me-0 text-dark fs--2 fw-normal">
                  <img src={logo} alt="logo" />
                </span>
              </div>

              {/* Center - Title */}
              <div className="text-center flex-grow-1 d-none d-lg-block">
                <h5 className="fw-bold mb-0">Inventory Monitoring System</h5>
              </div>

              {/* Right Side - User Info */}
              <div className="d-flex align-items-center">
                <span className="fs--1 me-3">{kitchenId.role}</span>
                <div className="nav-item dropdown">
                  <a
                    className="nav-link p-0 pt-1"
                    id="navbarDropdownUser"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <div className="avatar avatar-xl">
                      <img src={userIcon} alt="user" />
                    </div>
                  </a>
                  <div
                    className="dropdown-menu dropdown-caret dropdown-menu-end py-0"
                    aria-labelledby="navbarDropdownUser"
                  >
                    <div className="bg-white rounded-2 py-2">
                      <a className="dropdown-item" href="/">
                        Logout
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="collapse navbar-collapse bg-primary"
              id="navbarDoubleTop"
            >
              <div className="container-fluid">
                <ul
                  className="navbar-nav d-flex flex-row align-items-center gap-3 py-2"
                  data-top-nav-dropdowns="data-top-nav-dropdowns"
                >
                  {role_id === "admin" && (
                    <>
                      <li className="nav-item">
                        <a className="nav-link" href="/Dashboardv1">Dashboard</a>
                      </li>

                      <li className="nav-item">
                        <a className="nav-link" href="/dashboard_main">Main Dashboard</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="/dashboard">Home</a>
                      </li>


                    </>
                  )}
                  {role_id === "purchase" && (
                    <>
                      <li className="nav-item">
                        <a className="nav-link" href="/DashboardvMain1">Dashboard</a>
                      </li>

                      <li className="nav-item">
                        <a className="nav-link" href="/purchaseDashboard">Home</a>
                      </li>
                    </>
                  )}

                  {role_id === "admin" && (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Master
                      </a>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="/categorylist">
                            Category List
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/itemsList">
                            Item List
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/kitchenList">
                            Kitchen List
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="/vendorlist">
                            Vendor List
                          </a>
                        </li>
                      </ul>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Custom styles for horizontal scroll on small screens */}
      <style>{`
        @media (max-width: 991.98px) {
          .navbar-nav {
            flex-wrap: nowrap !important;
          }
          .navbar-nav .nav-item {
            white-space: nowrap;
          }
        }

        /* Prevent dropdown from causing scroll on desktop */
.dropdown-menu {
  max-width: 250px;
  overflow-x: hidden;
  white-space: normal;
}

/* Prevent scrollbars from appearing in navbar */
.navbar-nav {
  overflow: visible !important;
}

/* Optional: improve desktop layout spacing */
@media (min-width: 992px) {
  .navbar-nav {
    flex-wrap: wrap !important;
    gap: 1rem;
  }
}

      `}</style>
    </>
  );
};

export default Header;
